module.exports = __webpack_public_path__ + "img/ash.dae47675.jpg";